import React from "react";
import {AppInterface, selectAppById} from "src/store/community/appsSlice";
import Card from "src/componets/Card";
import FormFeed from "./_FormFeed";
import { Col, Form, message, Row } from "antd";
import Wrapper from "src/componets/Wrapper";
import PreviewCategories from "src/pages/community/Categories/_partials/_PreviewList";
import PreviewPosts from "src/pages/community/Posts/_partials/_PreviewList";
import PreviewAssets from "src/pages/community/Assets/_partials/_PreviewList";
import { useAppSelector } from "src/store/hooks";
import { feedApp } from "src/actions/community/appsActions";

const _Feed = ({ app } : { app: AppInterface | undefined }) => {
  const [form] = Form.useForm();
  const secondAppId = Form.useWatch('second_app_id', form);
  const target      = Form.useWatch('target', form) || 'content';
  const params: any = { app_id: app?.id, target, second_app_id: secondAppId };
  const secondApp = useAppSelector(state => secondAppId ? selectAppById(state, secondAppId) : undefined);
  const [loading, setLoading] = React.useState(false);
  const [selectedCategoryIds, setSelectedCategoryIds] = React.useState<number[]>([]);

  React.useEffect(() => {
    setSelectedCategoryIds([]);
  }, [secondAppId, target]);

  function onFinish(values: any) {
    if (!app) { return; }

    setLoading(true);

    const data = { ...values, category_ids: selectedCategoryIds.length ? selectedCategoryIds : undefined };

    feedApp(app?.id, data).then(() => {
      setLoading(false);
      message.success('Feed successfully');
    }).catch((error: any) => {
      setLoading(false);
      message.error(error?.response?.data?.message || error?.message);
    });
  }

  return (
    <div className='v-app-feed'>
      <Wrapper type='type-1' border className='v-mb-10'>
        <FormFeed
          form={form}
          onFinish={onFinish}
          params={params}
          loading={loading}
        />
      </Wrapper>

      <Row gutter={20}>
        <Col span={12}>
          <h4 className='v-content-title'>{secondApp?.name}</h4>
        </Col>

        <Col span={12}>
          <h4 className='v-content-title'>{app?.name}</h4>
        </Col>
      </Row>

      <Row gutter={20}>
        <Col span={12}>
          <Card className='v-mb-20'>
            <PreviewCategories
              app_id={secondAppId}
              target={target}
              selectable
              selectedIds={selectedCategoryIds}
              onSelect={setSelectedCategoryIds}
            />
          </Card>
        </Col>

        <Col span={12}>
          <Card className='v-mb-20'>
            <PreviewCategories app_id={app?.id} target={target} loading={loading} />
          </Card>
        </Col>
      </Row>

      <Row gutter={20}>
        <Col span={12}>
          <Card className='v-mb-20'>
            {target === 'content' && <PreviewPosts app_id={secondApp?.id} target={target} />}
            {target === 'assets' && <PreviewAssets app_id={secondApp?.id} target={target} />}
          </Card>
        </Col>

        <Col span={12}>
          <Card className='v-mb-20'>
            {target === 'content' && <PreviewPosts app_id={app?.id} target={target}  loading={loading} />}
            {target === 'assets' && <PreviewAssets app_id={app?.id} target={target}  loading={loading} />}
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default _Feed;
